import React, { PropTypes } from 'react';
import { Message as SuiMessage } from 'semantic-ui-react';

import Fading from '../../shared/fading/Fading';


const propTypes = {
  message: PropTypes.string,
};

const Message = ({ message }) => (
  <Fading>
    <SuiMessage
      key="message"
      size="large"
      icon="mail outline"
      content={message}
    />
  </Fading>
);

Message.propTypes = propTypes;
export default Message;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/components/forgottenPasswordCard/message/Message.js
 **/